import { ReactNode } from "react";

import { AppErrorFallback } from "./AppErrorFallback";
import { ErrorBoundary } from "./ErrorBoundary";

type AppErrorBoundaryProps = {
  children: ReactNode;
};

function AppErrorBoundary({ children }: AppErrorBoundaryProps) {
  return (
    <ErrorBoundary
      boundaryName="app"
      fallback={({ error, resetError }) => (
        <AppErrorFallback error={error} onRetry={resetError} />
      )}
    >
      {children}
    </ErrorBoundary>
  );
}

export { AppErrorBoundary };
